.placeholder {
	width: 100%;
	height: 100%;
	display: grid;
	place-items: center;
	/* A soft wash of the seeded accent (set inline) over the input tint, with
	   the icon a deeper shade of the same. Mixing toward --ink keeps it legible
	   and flips sensibly in dark mode. Falls back to muted ink if unset. */
	background: color-mix(
		in srgb,
		var(--placeholder-accent, var(--ink-muted)) 15%,
		var(--surface-input)
	);
	color: color-mix(
		in srgb,
		var(--placeholder-accent, var(--ink-muted)) 72%,
		var(--ink)
	);
	/* Size the icon relative to the shorter side so it reads well in a wide
	   hero and a small square thumbnail alike. */
	container-type: size;
	/* Pick up a rounded parent (e.g. the compact thumbnail) where present. */
	border-radius: inherit;
}

.icon {
	width: 40cqmin;
	height: 40cqmin;
}
